module.exports = __webpack_public_path__ + "fonts/IGUIBetav9.8bcf5a52.woff";